import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class AuthService extends BaseService {

  public redirectOnLogin: string[] = null;

  public login(email: string, password: string): Observable<any> {
    return this.http.post(this.url('login'), {email, password})
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public checkFBToken() {

    return this.http.get(this.url('check-fb-token'), this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public getFBAuthNumber() {
    return this.http.get(this.url('get-fb-auth-number'), this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public waitForFBAuth() {
    return this.http.get(this.url('wait-for-fb-auth'), this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/services/auth.service.ts